import { z } from 'zod';

export const baseWeightPerformanceFormSchema = z.object({
    weightKg: z.number().min(0).nullable().optional(),
    date: z.date(),
});

export const createWeightPerformanceFormSchema = baseWeightPerformanceFormSchema
    .extend({
        userId: z.string().nonempty({ message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .superRefine((data, ctx) => {
        if (data.isTiedToAssessmentRun && !data.assessmentRunId) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Assessment run is required when tying to an assessment run',
                path: ['assessmentRunId'],
            });
        }
    });

export type CreateWeightPerformanceFormData = z.infer<typeof createWeightPerformanceFormSchema>;

export type EditWeightPerformanceFormData = z.infer<typeof baseWeightPerformanceFormSchema> & {
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const weightPerformanceDefaultFormValues: CreateWeightPerformanceFormData = {
    weightKg: null,
    date: new Date(),
    assessmentRunId: null,
    isTiedToAssessmentRun: false,
    userId: '',
};
